/**
 * NewsLetter
 *
 * Form-creator (ajax with jquery): https://app.ungapped.com/Web/SubscriptionForms
 */
const NewsLetter = {
  formEl: null,
  emailEl: null,
  doubleOptIdEl: null,
  policyEl: null,
  responseDiv: null,
  successText: "",
  errorTerms: "",
  errorGeneric: "",
  errorEmailEmpty: "",
  errorEmailWrong: "",
  errorSubscriber: "",

  init: () => {
    // get elements
    NewsLetter.formEl = document.getElementById("block-newsletter__form");
    NewsLetter.emailEl = document.getElementById("contactEmail");
    NewsLetter.doubleOptIdEl = document.getElementById("double-opt-id");
    NewsLetter.policyEl = document.getElementById("contactConsentText");
    NewsLetter.responseDiv = document.getElementById(
      "block-newsletter-response"
    );

    // get validation strings
    if (NewsLetter.responseDiv) {
      NewsLetter.successText = NewsLetter.responseDiv.dataset.successText;
      NewsLetter.errorTerms = NewsLetter.responseDiv.dataset.errorTerms;
      NewsLetter.errorGeneric = NewsLetter.responseDiv.dataset.errorGeneric;
      NewsLetter.errorEmailEmpty =
        NewsLetter.responseDiv.dataset.errorEmailEmpty;
      NewsLetter.errorEmailWrong =
        NewsLetter.responseDiv.dataset.errorEmailWrong;
      NewsLetter.errorSubscriber =
        NewsLetter.responseDiv.dataset.errorSubscriber;

      // console.log("1: ", NewsLetter.successText);
      // console.log("2: ", NewsLetter.errorTerms);
      // console.log("3: ", NewsLetter.errorGeneric);
      // console.log("4: ", NewsLetter.errorEmailEmpty);
      // console.log("5: ", NewsLetter.errorEmailWrong);
      // console.log("6: ", NewsLetter.errorSubscriber);
    }

    // submit
    if (NewsLetter.formEl) {
      NewsLetter.formEl.addEventListener("submit", (e) => {
        e.preventDefault();

        // get values
        let email = NewsLetter.emailEl.value;
        let doubleOptId = NewsLetter.doubleOptIdEl.value;
        let policy = NewsLetter.policyEl.checked;

        if (!policy) {
          if (NewsLetter.responseDiv)
            NewsLetter.responseDiv.innerHTML = NewsLetter.errorTerms;
        } else {
          NewsLetter.ajaxRequest(email, doubleOptId);
        }
      });
    }
  },

  ajaxRequest: (email, doubleOptId) => {
    const $ = jQuery;

    $.ajax({
      type: "post",
      dataType: "json",
      url: "https://ui.ungpd.com/Api/Subscriptions/dd32c31b-4cd6-41e3-8ec3-d70d98d0b2e9/ajax",
      data: {
        ListIds: ["d9569649-1363-45c7-9d3c-42f95da584b7"],
        Contact: {
          Email: email,
        },
        ConsentText:
          "Jag vill få relevant information från Net Zero Industry till min inkorg. Net Zero Industry ska inte dela eller sälja mina personuppgifter. Jag kan avsluta prenumerationen när som helst.",
        DoubleOptIn: {
          Issue: { IssueId: doubleOptId },
        },
      },
      statusCode: {
        200: function (res) {
          console.log("success");
          NewsLetter.responseDiv.innerHTML = NewsLetter.successText;
        },
        400: function (xhr, status, error) {
          console.log("400");
          const message = xhr.responseJSON.Message;
          console.log(message);
          console.log(xhr.responseJSON);

          let response = NewsLetter.errorGeneric;

          if (message == "No contact information provided") {
            response = NewsLetter.errorEmailEmpty;
          } else if (message == "Invalid email") {
            response = NewsLetter.errorEmailWrong;
          } else if (message == "Subscription already exists") {
            response = NewsLetter.errorSubscriber;
          } else {
            response = message;
          }

          NewsLetter.responseDiv.innerHTML = response;
        },
      },
    });

    return false;
  },
};

export default NewsLetter;
